import { z } from '@harvestiq/zod';
import { dbCampaignUpdateSchema } from './db-campaigns';
import {
  LivestockInsuranceTypes,
  RmaLgmCommodityCodes,
  RmaLgmTypeCodes,
  RmaLrpCommodityCodes,
  RmaLrpTypeCodes,
} from '@harvestiq/constants';

const baseUpdateCampaignRequestSchema = dbCampaignUpdateSchema
  .omit({
    createdAt: true,
    updatedAt: true,
  })
  .extend({
    sendEmailIds: z.array(z.string().uuid()).optional(),
    sendSmsIds: z.array(z.string().uuid()).optional(),
  });

export const updateLrpCampaignRequestSchema = baseUpdateCampaignRequestSchema
  .omit({
    insuranceType: true,
    commodity: true,
    typeCode: true,
    deductibles: true,
    liveCattleTargetCwtPerHead: true,
    feederCattleTargetCwtPerHead: true,
    cornTargetBuPerHead: true,
    marketingLengths: true,
  })
  .extend({
    insuranceType: z.literal(LivestockInsuranceTypes.LRP).optional(),
    commodity: z.nativeEnum(RmaLrpCommodityCodes).optional(),
    typeCode: z.nativeEnum(RmaLrpTypeCodes).optional(),
  });

export type UpdateLrpCampaignRequest = z.input<
  typeof updateLrpCampaignRequestSchema
>;

export const updateLgmCampaignRequestSchema = baseUpdateCampaignRequestSchema
  .omit({
    insuranceType: true,
    commodity: true,
    typeCode: true,
    targetWeight: true,
    coverageTier: true,
  })
  .extend({
    insuranceType: z.literal(LivestockInsuranceTypes.LGM).optional(),
    commodity: z.nativeEnum(RmaLgmCommodityCodes).optional(),
    typeCode: z.nativeEnum(RmaLgmTypeCodes).optional(),
  });

export type UpdateLgmCampaignRequest = z.input<
  typeof updateLgmCampaignRequestSchema
>;

// Use discriminated union for proper type discrimination
export const updateCampaignRequestSchema = z.discriminatedUnion(
  'insuranceType',
  [
    updateLrpCampaignRequestSchema.extend({
      insuranceType: z.literal(LivestockInsuranceTypes.LRP),
    }),
    updateLgmCampaignRequestSchema.extend({
      insuranceType: z.literal(LivestockInsuranceTypes.LGM),
    }),
  ]
);

export type UpdateCampaignRequest = z.input<typeof updateCampaignRequestSchema>;

export const updateCampaignRequestParamsSchema = z.object({
  campaignId: z.string().uuid(),
});
export type UpdateCampaignRequestParams = z.infer<
  typeof updateCampaignRequestParamsSchema
>;
